import * as A from '@/api';
import { ConstructorInput } from './dashboardWidgetFactory';

// const ns = 'app.services.abstractDashboardWidget';

export default abstract class AbstractDashboardWidget {
  readonly id: string;

  readonly dashboardId: string;

  readonly type: A.DashboardWidgetType;

  position: {
    x: number;
    y: number;
    w: number;
    h: number;
    minH?: number;
    minW?: number;
    maxH?: number;
    maxW?: number;
    static?: boolean;
  };

  state: 'new' | 'clean' | 'dirty' | 'removed' | 'discarded';

  constructor(input: ConstructorInput) {
    this.id = input.id;
    this.dashboardId = input.dashboardId;
    this.type = input.type;
    this.position = JSON.parse(input.position);
    this.state = input.state;
  }

  abstract getConfigurations(): unknown;
}
